import { BlueticksForm } from "@common-models/form";
import { TaskColumn } from "@common-models/task-column";
import { createSelector } from "@reduxjs/toolkit";
import { formSelectByQuery, formSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { dynamicColumnListForForms } from "./TaskSelectors";
import { CommonRootState } from "@common/types/common-root-state-type";

export const formColumnList = createSelector( /// create a selector that updates order of column, if its missing from the form's columnData and return
  /// a list of columns that is sorted by the order of the columnData's column order
  [
    (state: CommonRootState, columnData, boardId) => (state),
    (state: CommonRootState, columnData, boardId) => (columnData),
    (state: CommonRootState, columnData, boardId) => (boardId),
  ],
  (state: CommonRootState, columnData, boardId) => {
    const columnList = dynamicColumnListForForms(state, boardId)
    const sortedColumnList = columnList?.sort((a, b) => {
      const aId = a._id ?? '';
      const bId = b._id ?? '';
      const aOrder =
        columnData === undefined ||
          columnData[aId] === undefined ||
          columnData[aId].order === undefined
          ? columnList.length + 1
          : columnData[aId].order;
      const bOrder =
        columnData === undefined ||
          columnData[bId] === undefined ||
          columnData[bId].order === undefined
          ? columnList.length + 1
          : columnData[bId].order;
      return aOrder - bOrder;
    })
    return sortedColumnList.map((column, index) => ({ _id: column._id, type: column.type, title: column.title } as TaskColumn));
  }
);


export const getSortedVisibleColumnList = createSelector( /// create a selector that updates order of column, if its missing from the form's columnData and return
  /// a list of columns that is sorted by the order of the columnData's column order
  [
    (state: CommonRootState, columnData, boardId, formId) => (state),
    (state: CommonRootState, columnData, boardId, formId) => (columnData),
    (state: CommonRootState, columnData, boardId, formId) => (boardId),
    (state: CommonRootState, columnData, boardId, formId) => (formId),
  ],
  (state: CommonRootState, columnData, boardId, formId) => {
    
    const form = formSelectOneObjectByQuery(state.DBFormReducer, {
      _id: formId,
      boardId,
      $or: [{ deleted: { $exists: false } }, { deleted: false }],
    })
    const sortedColumnList = formColumnList(state, columnData, boardId)
    .filter(column => {
      const colId = column._id ?? '';
      const colData = form?.columnData?.[colId];
      return colData === undefined || colData.visible === undefined || colData.visible;
    })

    return sortedColumnList.map((column, index) => ({ _id: column._id, type: column.type, title: column.title } as TaskColumn));
  }
);


export const formIdList = createSelector(
  [
    (state: CommonRootState, boardId: string) => formSelectByQuery(state.DBFormReducer, { boardId })
  ],
  (formList: BlueticksForm[]) => {
    const formIdList = formList.map((kanban) => kanban._id)
    return formIdList
  }
);
// export interface FormsState {
//   formEditModeByFormId: string;
// }

// const initialState: FormsState = {
//   formEditModeByFormId: "",
// };

// const FormsSlice = createSlice({
//   name: "forms",
//   initialState,
//   reducers: {
//     setFormEditModeByFormId(state, { payload }: PayloadAction<string>) {
//       state.formEditModeByFormId = payload
//     },
//   }
// });

// export const formsActions = FormsSlice.actions;
// export default FormsSlice.reducer;
